import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.array.sort.js";
import { addUniqueItem, removeItem } from '../../utils/array.mjs';
import { compareByDepth } from './compare-by-depth.mjs';
var FlatTree = /*#__PURE__*/function () {
  function FlatTree() {
    _classCallCheck(this, FlatTree);
    this.children = [];
    this.isDirty = false;
  }
  return _createClass(FlatTree, [{
    key: "add",
    value: function add(child) {
      addUniqueItem(this.children, child);
      this.isDirty = true;
    }
  }, {
    key: "remove",
    value: function remove(child) {
      removeItem(this.children, child);
      this.isDirty = true;
    }
  }, {
    key: "forEach",
    value: function forEach(callback) {
      this.isDirty && this.children.sort(compareByDepth);
      this.isDirty = false;
      this.children.forEach(callback);
    }
  }]);
}();
export { FlatTree };